<template>
    <div class="banner-element columns is-gapless is-centered">
        <div class="colum">
            <figure class="image">
                <LazyLoadedImage class=" " :src="imgSrc" alt="Hero Banner"></LazyLoadedImage>
            </figure>
        </div>
    </div>
</template>

<script>
    import LazyLoadedImage from "../shared/LazyLoadedImage";

    export default {
        name: "Banner",
        components: {LazyLoadedImage},
        data() {
            return {}
        },

        props: {
            contentData: {
                type: Object,
                required: true
            }
        },
        computed: {
            imgSrc() {
                return this.contentData.content.gallery.rows[1].columns[1].publicUrl
            },
            title() {
                return this.contentData.content.header;
            },
            subtitle() {
                return this.contentData.content.subheader;
            }
        }
    }
</script>

<style lang="scss">
    .cms-view__content{
        .cms-view__element{
            .banner-element {
                width: 100%;
                margin-bottom: 2rem;
                margin-top: 1rem;
            }
        }
    }
</style>